module.exports = __webpack_public_path__ + "static/media/item-18.b1ae4081.png";